// extracted by mini-css-extract-plugin
export default {"fondo":"classroomProf_fondo__0qmFk","topDiv":"classroomProf_topDiv__tRisQ"};